import { PaymentMode, SelectedPaymentMode } from '@checkout-v2/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { ACTIVE_PAYMENT_MODE, PAYMENT_MODE_LIST } from '../checkout-state';

export const LOAD_PAYMENT_MODE_LIST = '[Checkout] Load payment mode list';
export const LOAD_PAYMENT_MODE_LIST_SUCCESS = '[Checkout] Load payment mode list success';
export const LOAD_PAYMENT_MODE_LIST_FAIL = '[Checkout] Load payment mode list fail';
export const LOAD_PAYMENT_MODE_LIST_RESET_STATE = '[Checkout] Load payment mode list reset state';

export const SET_ACTIVE_PAYMENT_MODE = '[Checkout] Set active payment mode';
export const SET_ACTIVE_PAYMENT_MODE_SUCCESS = '[Checkout] Set active payment mode success';
export const SET_ACTIVE_PAYMENT_MODE_FAIL = '[Checkout] Set active payment mode fail';
export const SET_ACTIVE_PAYMENT_MODE_RESET_STATE = '[Checkout] Set active payment mode reset state';

// запрос на перенаправление на страницу привязки новой карты
export const INIT_CARD_BINDING = '[Checkout] Init card binding';

export class LoadPaymentModeList extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PAYMENT_MODE_LIST;

  constructor() {
    super(PAYMENT_MODE_LIST);
  }
}

export class LoadPaymentModeListSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PAYMENT_MODE_LIST_SUCCESS;

  constructor(public payload: PaymentMode[]) {
    super(PAYMENT_MODE_LIST);
  }
}

export class LoadPaymentModeListFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_PAYMENT_MODE_LIST_FAIL;

  constructor() {
    super(PAYMENT_MODE_LIST);
  }
}

export class LoadPaymentModeListResetState extends StateUtils.LoaderResetAction {
  readonly type = LOAD_PAYMENT_MODE_LIST_RESET_STATE;

  constructor() {
    super(PAYMENT_MODE_LIST);
  }
}

export class SetActivePaymentMode extends StateUtils.LoaderLoadAction {
  readonly type = SET_ACTIVE_PAYMENT_MODE;

  constructor(public payload: { paymentMode: SelectedPaymentMode | undefined }) {
    super(ACTIVE_PAYMENT_MODE);
  }
}

export class SetActivePaymentModeSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = SET_ACTIVE_PAYMENT_MODE_SUCCESS;

  constructor(public payload: SelectedPaymentMode | undefined) {
    super(ACTIVE_PAYMENT_MODE);
  }
}

export class SetActivePaymentModeFail extends StateUtils.LoaderFailAction {
  readonly type = SET_ACTIVE_PAYMENT_MODE_FAIL;

  constructor() {
    super(ACTIVE_PAYMENT_MODE);
  }
}

export class InitCardBinding implements Action {
  readonly type = INIT_CARD_BINDING;
}

export type PaymentModesActions =
  | LoadPaymentModeList
  | LoadPaymentModeListSuccess
  | LoadPaymentModeListFail
  | LoadPaymentModeListResetState
  | SetActivePaymentMode
  | SetActivePaymentModeSuccess
  | SetActivePaymentModeFail
  | InitCardBinding;
